<script>
    import Carousel from 'svelte-carousel';
    import { store } from '../../store.js';
    export let carousel;
    export let imageWidth = $store.type === 'pc' ? 120 : 70;
</script>

<Carousel
    autoplay
    autoplayDuration={5000}
    particlesToShow={$store.type === 'pc' ? 6 : 4}
    particlesToScroll={$store.type === 'pc' ? 6 : 4}
    arrows={true}
    dots={false}
    bind:this={carousel}
    let:showPrevPage
    let:showNextPage
>
    <div slot="prev" on:click={showPrevPage} class="carousel-arrow">
        <i class="bi bi-chevron-left"></i>
    </div>
    {#each Array(16) as _, i}
        {#if i > 0}
            <div class="brand-logo">
                <img 
                    src={`/images/brands/brand_${i}.png`} 
                    alt={`brand_${i}`}
                    style={`
                            width: ${imageWidth}px; 
                            height: ${imageWidth}px;
                            object-fit:contain;
                        `} 
                    />
            </div>
        {/if}
    {/each}
    <div slot="next" on:click={showNextPage} class="carousel-arrow">
        <i class="bi bi-chevron-right"></i>
    </div>
</Carousel>

<style>

.brand-logo {
    text-align: center;
}

.carousel-arrow {
    font-size: 5vw;
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-top: -2vw;
}
</style>